import Checkbox from '@/components/ui/Checkbox';
import { FormControl, FormField, FormItem } from '@/components/ui/Form';

import { useLingui } from '@lingui/react';

const CheckboxWithoutPESEL = ({ name }: { name: string }) => {
  const { i18n } = useLingui();
  return (
    <FormField
      name={name}
      render={({ field }) => {
        const { value, onChange, onBlur, ...restField } = field;
        return (
          <FormItem className="col-span-4 md:col-span-2">
            <FormControl>
              <Checkbox
                variant={'filled'}
                label={i18n.t('Nie mam PESEL')}
                value={value}
                defaultChecked={value}
                onCheckedChange={onChange}
                onBlur={onBlur}
                className="p-[14px] outline-dark-gray-200 lg:p-4"
                {...restField}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};

export default CheckboxWithoutPESEL;
